import React, { useState } from 'react';
import { Button, Table, Select, Upload, Card, Typography, Row, Col } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const DocumentUpload = ({ onBack, onInsertSuccess }) => {
  const [selectedPlant, setSelectedPlant] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const plantOptions = [
    { value: 'pp3', label: 'PP3 - Polipropileno' },
    { value: 'pp2', label: 'PP2 - Teste' },
  ];

  const columns = [
    {
      title: 'Código',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Descrição',
      dataIndex: 'description',
      key: 'description',
    },
  ];

  const handleUploadFiles = (file) => {
    const newFile = {
      name: file.name,
      status: 'processing',
      uid: file.uid
    };
    setUploadedFiles(prev => [...prev, newFile]);
    
    setTimeout(() => {
      setUploadedFiles(prev => 
        prev.map(f => 
          f.uid === file.uid 
            ? { ...f, status: 'processed', assets: generateMockAssets(file.name) }
            : f
        )
      );
    }, 2000);
    
    return false;
  };

  const generateMockAssets = (fileName) => {
    return [
      { key: Math.random().toString(), code: 'F301', description: `Asset from ${fileName}` },
      { key: Math.random().toString(), code: 'F302', description: `Equipment from ${fileName}` }
    ];
  };

  const handleInsertFromFiles = () => {
    if (selectedPlant && onInsertSuccess) {
      onInsertSuccess();
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 24, display: 'flex', gap: 8, alignItems: 'center' }}>
        <Button onClick={onBack}>
          ← Voltar
        </Button>
        <Title level={2} style={{ margin: 0 }}>Upload de Arquivos</Title>
      </div>

      <div style={{ marginBottom: 24 }}>
        <Upload
          beforeUpload={handleUploadFiles}
          showUploadList={false}
          multiple
        >
          <Button icon={<UploadOutlined />} type="primary" size="large">
            Selecionar Arquivos
          </Button>
        </Upload>
        <Text type="secondary" style={{ marginLeft: 16 }}>
          Selecione um ou múltiplos arquivos para processamento
        </Text>
      </div>

      {uploadedFiles.length > 0 && (
        <div>
          <Title level={3}>Arquivos Processados</Title>
          <Row gutter={[16, 16]}>
            {uploadedFiles.map(file => (
              <Col span={24} key={file.uid}>
                <Card style={{ marginBottom: 16 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <Title level={4} style={{ margin: 0 }}>{file.name}</Title>
                    {file.status === 'processing' ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Text>Processando...</Text>
                      </div>
                    ) : (
                      <Text type="success" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        ✓ Processado
                      </Text>
                    )}
                  </div>
                  
                  {file.status === 'processed' && file.assets && (
                    <div>
                      <Text type="secondary" style={{ marginBottom: 12, display: 'block', fontSize: '16px' }}>
                        Ativos encontrados ({file.assets.length}):
                      </Text>
                      <Table
                        columns={columns}
                        dataSource={file.assets}
                        pagination={false}
                        size="middle"
                        style={{ backgroundColor: '#fafafa' }}
                      />
                    </div>
                  )}
                </Card>
              </Col>
            ))}
          </Row>
          
          <Card style={{ marginTop: 24, textAlign: 'center', backgroundColor: '#f0f8ff' }}>
            <Title level={4}>Finalizar Inserção</Title>
            <div style={{ marginBottom: 16 }}>
              <Select
                placeholder="Selecione uma planta"
                style={{ width: 250, marginRight: 16 }}
                options={plantOptions}
                value={selectedPlant}
                onChange={setSelectedPlant}
                size="large"
              />
              <Button 
                type="primary" 
                size="large"
                onClick={handleInsertFromFiles}
                disabled={!selectedPlant || uploadedFiles.some(f => f.status === 'processing')}
              >
                Inserir Todos os Ativos ({uploadedFiles.reduce((total, file) => total + (file.assets?.length || 0), 0)} ativos)
              </Button>
            </div>
            <Text type="secondary">
              Todos os ativos dos arquivos processados serão inseridos na planta selecionada
            </Text>
          </Card>
        </div>
      )}
    </div>
  );
};

export default DocumentUpload;